import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {RestComponent} from './lib/RestComponent';
import {getTitle} from './lib/helpers';
import {CatalogItem, CatalogService} from './catalog/catalog.service';
import {BreadCrumbsService} from './breadcrumbs.service';
import {defaultNavParams, defaultOrder} from './catalog-items-default.component';
import {FilterService} from './filter.service';
import {CookieService} from 'ngx-cookie';
import {ConsultService} from './consult.service';
import {NotificationService} from './notification.service';
import {CityService} from './city.service';
import UIkit from './lib/uikit';
import $ from './lib/jquery';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'home-page',
  templateUrl: '../templates/home-page.component.html',
  styleUrls: ['../styles/components/home-page.component.less']
})
export class HomePageComponent extends RestComponent implements OnInit, OnDestroy {
  catalog: CatalogItem[] = [];
  navParams: any = defaultNavParams;
  order: any = defaultOrder;
  filter: any = {ACTIVE: 'Y'};
  isPaginationReady: boolean = false;
  isCatalogReady: boolean = false;

  activeSort: any = {name: null, value: null};
  countPages: number = 0;
  count: number = 0;
  filterDisplay: any = {
    isHidden: false,
    isOverflow: false
  };
  @ViewChild('catalogTitle', { static: false }) catalogTitleRef: ElementRef;

  constructor(
    private catalogService: CatalogService,
    private titleService: Title,
    private metaService: Meta,
    private breadCrumbsService: BreadCrumbsService,
    public filterService: FilterService,
    private cookie: CookieService,
    private consult: ConsultService,
    private notificationService: NotificationService,
    public cityService: CityService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
    
    this.breadCrumbsService.create();
  }

  public async ngOnInit() {
    const activeTarget = this.cookie.get('target');
    const activeActivity = this.cookie.get('activity');
    const targetArr: string[] = [];
    if (activeTarget) targetArr.push(activeTarget);
    if (activeActivity) targetArr.push(activeActivity);
    this.filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), {'PROPERTY_TAGS.XML_ID': targetArr});
    try {
      this.catalog = await this.catalogService.get({
        order: this.order,
        filter: this.filter,
        navParams: this.navParams
      });
      this.isCatalogReady = true;

      const countItems = await this.catalogService.getCount({
        filter: this.filter
      });
      this.count = countItems.count;
      this.countPages = Math.ceil(countItems.count / this.navParams.nPageSize);
      this.isPaginationReady = true;
    } catch (e) {
      this.consult.notification({
        name: 'Ошибка в соединении. Попробуйте повторить запрос',
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      return false;
    }

    if (this.filterService.activeTargetAudience || this.filterService.activeActivity) {
      this.filterDisplay.isOverflow = true;
      this.filterDisplay.isHidden = true;
    }

    this.subscription = this.filterService.changeActive.subscribe((target: any) => {
      const targetArray: string[] = [];
      if (this.filterService.activeTargetAudience) targetArray.push(this.filterService.activeTargetAudience._id);
      if (this.filterService.activeActivity) targetArray.push(this.filterService.activeActivity._id);
      if (targetArray.length > 0) {
        this.filterDisplay.isOverflow = true;
        this.filterDisplay.isHidden = true;
      } else {
        this.filterDisplay.isHidden = false;
        window.setTimeout(() => { // remove overflow and update sliders after animation
          this.filterDisplay.isOverflow = false;
          UIkit.update(document.querySelector('.ShortCodeFilter'), 'update');
        }, 400);
      }
      this.changeFilter({'PROPERTY_TAGS.XML_ID': targetArray});
    });

    const regionId = this.activatedRoute.snapshot.params['id'];
    if (regionId) {
      this.cityService.city = await this.cityService.get({
          filter: {CODE: regionId}
        }
      ).then(cities => cities[0]);
    }
    if(this.cityService.city.PROPERTY_INFLECTED_VALUE != 'России') {
      this.titleService.setTitle(getTitle(`Купить торговое оборудование и программы для магазинов и ресторанов - Магазин ИТ услуг в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`));
      this.metaService.updateTag({
        name: 'description',
        content: `Интернет магазин торгового оборудования. Купить торговое оборудование и программы для магазинов и ресторанов - Магазин ИТ услуг в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}. Наш телефон: 8-800-775-73-99 - Золотой код`
      });
    }
    else {
      this.titleService.setTitle(getTitle(`Купить торговое оборудование и программы для магазинов и ресторанов - Магазин ИТ услуг`));
      this.metaService.updateTag({
        name: 'description',
        content: `Интернет магазин торгового оборудования. Купить торговое оборудование и программы для магазинов и ресторанов - Магазин ИТ услуг. Наш телефон: 8-800-775-73-99 - Золотой код`
      });
    }
  }

  public ngOnDestroy() {
    defaultNavParams.iNumPage = 1;
    this.subscription.unsubscribe();
  }

  public async changeOrder(sort: any) {
    this.order = sort;
    this.isPaginationReady = false;
    this.resetList();
    await this.loadPage();
    this.isPaginationReady = true;
  }

  public async changeFilter(filter: object) {
    this.filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), filter);
    this.isPaginationReady = false;

    let countItems: {count: number};
    try {
      countItems = await this.catalogService.getCount({
        filter: this.filter
      });
    } catch (e) {
      countItems = {count: 0};
    }
    this.count = countItems.count;

    this.countPages = Math.ceil(this.count / this.navParams.nPageSize);

    this.resetList();
    await this.loadPage();
    this.isPaginationReady = true;

    this.notificationService.show({
      message: `Найдено ${this.count} товаров`,
      status: 'success'
    });
  }

  public async changePage(page: number) {
    this.navParams.iNumPage = page;
    await this.loadPage();
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        $('html, body').animate({scrollTop: (this.catalogTitleRef.nativeElement.offsetTop - 70)}, 1000);
      }, 700);
    }
  }

  public async loadPage() {
    this.isCatalogReady = false;
    this.loadingState = true;
    try {
      const items: CatalogItem[] = await this.catalogService.get({
        order: this.order,
        filter: this.filter,
        navParams: this.navParams
      });

      this.catalog = items;

      this.loadingState = false;
      this.isCatalogReady = true;

      return this.catalog;
    } catch (err) {
      this.error = true;
      this.consult.notification({
        name: 'Ошибка в соединении. Попробуйте повторить запрос',
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }

  }

  private resetList() {
    this.navParams.iNumPage = 1;
  }
}
